import { useCallback, useState } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'

interface Props extends DialogProps {
  onDelete: () => Promise<void>
}

export const ConfirmDeleteMessageEditorDialog = ({
  isOpen,
  onClose,
  onDelete,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleDelete = useCallback(async () => {
    setIsLoading(true)
    try {
      await onDelete?.()
      onClose()
    } catch (error) {
      console.log('error ConfirmDeleteDialog ', error)
      setIsLoading(false)
    }
  }, [onClose, onDelete])

  return (
    <Dialog show={isOpen}>
      <Dialog.Header>
        <Dialog.Title>Confirmation Required</Dialog.Title>
        <Dialog.Description className="text-center">
          Are you sure you want to remove this message?
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.ClosableFooter
        className="mt-6"
        onClose={onClose}
      >
        <Button
          variant="destructive"
          onClick={handleDelete}
          isLoading={isLoading}
        >
          Remove
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
